import React, { Component } from "react";
import { connect } from "react-redux";
import CardForm from "Utils/Cards/CardForm";
import { CreacionTrasladoForm } from "./components/CreacionTrasladoForm";
import "./styles/CreacionTraslado.css";

class CreacionTraslado extends Component {
    regresar = () => {
        this.props.history.goBack();
    };

    navigateToBoleta = (trasladoId) => {
        this.props.history.replace(
            `/produccion-bodega/control-calidad/${trasladoId}/ver-boleta`,
        );
    };

    render() {
        const { user } = this.props;

        const nombreUsuario = user ? user.nombre : "No definido";

        return (
            <div className="mb-4 col-12" style={{ maxWidth: "95vw" }}>
                <CardForm
                    icon="produccion_activo"
                    titulo="Bodega producto terminado"
                    subtitulo="Traslados conforme/no conforme"
                    col="12"
                >
                    <CreacionTrasladoForm
                        regresar={this.regresar}
                        navigateToBoleta={this.navigateToBoleta}
                        nombreUsuario={nombreUsuario}
                    />
                </CardForm>
            </div>
        );
    }
}

const mstp = (state) => {
    const user = state.login.me;

    return {
        user,
    };
};

export default connect(mstp, {})(CreacionTraslado);
